import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AOSetup } from './ao-setup';
import { SubscriberTermination } from './subscriber-termination';
import { RoleGroup } from '../../entity-details/entity-details-tab/role-group-tabs/role-group-tab/role-group';
import { GridResponse } from '../grid/grid-response';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private httpClient: HttpClient) { }

  hasAOSetup(): Observable<AOSetup> {
    const url = '/v1/customers/aosetup';
    return this.httpClient.get<AOSetup>(url);
  }

  hasSubscriberTermination(): Observable<SubscriberTermination> {
    const url = '/v1/distributors/users/allowSubscriberTermination';
    return this.httpClient.get<SubscriberTermination>(url);
  }

  hasSystemRoleGroups(): Observable<boolean> {
    const url = '/v1/customers/systemRoleGroups/company';
    return this.httpClient.get<GridResponse<RoleGroup>>(url, { observe: 'response' })
      .pipe(map((response) => {
        if (response.body && response.body?.totalNumberOfRecords > 0) {
          return true;
        } else {
          return false;
        }
      }))
  }

}
